import { resizedataURL } from './printElement';
import { base64ToBlob } from './formaterBanner';

export async function MasterToReplicate(banner, format) {
  const aspectRatioX =  format.width / banner.width;
  const aspectRatioY = format.height / banner.height;
  const aspectRatio = (Math.min(aspectRatioX, aspectRatioY) * 100).toFixed(0);
  const aspectRatioBG = (Math.max(aspectRatioX, aspectRatioY) * 100).toFixed(0);
  banner.elements.forEach(async (element) => {
    if (element.properties && !element.parent) {
      if (element.type === "bg" || element.id.includes("bg")) {
        element.properties.scale = aspectRatioBG;
        const bgX = element.properties.width * aspectRatioBG / 100;
        const bgY = element.properties.height * aspectRatioBG / 100;
        const left = format.width - bgX;
        const top = format.height - bgY;
        element.properties.left = left / 2;
        element.properties.top = top / 2;
      } else {
        const centerX = element.properties.left;
        const centerY = element.properties.top;
        const elX = centerX * aspectRatioX;
        const elY = centerY * aspectRatioY;
        element.properties.scale = aspectRatio;
        element.properties.top = Math.ceil(elY).toFixed(0);
        element.properties.left = Math.ceil(elX).toFixed(0);
      }
    }
    
    if (element.reduce) {
      const bg = element.properties.originalBackground.replaceAll("'", "");
      element.properties.background = await resizedataURL(bg, element.properties.width * element.properties.scale / 100, element.properties.height * element.properties.scale / 100);
      const blob = base64ToBlob(element.properties.background);
      const blobUrl = URL.createObjectURL(blob);
      element.properties.blob = blobUrl;
    }
  });
  banner.width = format.width;
  banner.height = format.height;
  return banner;
}
